import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {MobileWebViewService} from './mobile-web-view.service';

@Injectable({
	providedIn: 'root'
})
export class MobileWebViewGuard implements CanActivate {
	constructor(private mobileService: MobileWebViewService, private router: Router) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (this.mobileService.isMobileWebViewUser()) {
			return true;
		} else {
			this.router.navigate(['/login']);
		}
	}
}
